import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'
import {useEffect, useRef, useState} from 'react'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import {Dropdown} from 'react-bootstrap'
import './style.css'
import EditableTable from './EditableTable'
import CreateRateModal from './CreateRateModal'
import {BulkCustomerRateUploadModal} from './components/BulkCustomerRateUploadModal'
import axios from 'axios'
import {useParams} from 'react-router-dom'
import RateCustomerFilterDropdown from './RateCustomerFilterDropdown'
import {useAuth} from '../../../modules/auth'
import {CommonLoading} from '../../../../Utils/commonLoading'
import Select from 'react-select'

const API_URL = process.env.REACT_APP_API_URL
const itemsPerPage = Number(process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE) || 10

export function RateAccountView() {
  let {id} = useParams()
  const {currentUser} = useAuth()
  const [languages, setLanguages] = useState([])
  const [languageGroups, setLanguageGroups] = useState([])
  const [serviceTypes, setServiceTypes] = useState([])
  const [communicationTypes, setCommunicationTypes] = useState([])
  const [initialRows, setInitialRows] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [customerInfo, setCustomerInfo] = useState<any>(null)

  // Copy Rates state
  const [showCopyModal, setShowCopyModal] = useState(false)
  const [showCopyConfirm, setShowCopyConfirm] = useState(false)
  const [allCustomers, setAllCustomers] = useState<any[]>([])
  const [selectedSourceCustomer, setSelectedSourceCustomer] = useState<any>(null)
  const [isCopying, setIsCopying] = useState(false)
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false)

  const [filterValues, setFilterValues] = useState<{
    fK_LanguageFrom: any
    fK_LanguageTo: any[]
    fK_ServiceType: any[]
    fK_CommunicationType: any[]
    status: string
  }>({
    fK_LanguageFrom: null,
    fK_LanguageTo: [],
    fK_ServiceType: [],
    fK_CommunicationType: [],
    status: 'all',
  })
  // pagination
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(itemsPerPage)
  const [totalItems, setTotalItems] = useState<number>(0)

  const fetchLanguages = async () => {
    try {
      let response = await axios.get(`${API_URL}/master/languages/active-shortlist`)
      setLanguages(response.data.data)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchLanguageGroups = async () => {
    try {
      let response = await axios.get(`${API_URL}/LanguageGroups/active-shortlist`)
      setLanguageGroups(response.data.data || [])
    } catch (error) {
      console.error(error)
    }
  }

  const fetchAllCommunicationType = async () => {
    try {
      let response = await axios.get(`${API_URL}/master/getall/COMMUNICATION_TYPE`)
      setCommunicationTypes(response.data.data)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchAllServices = async () => {
    try {
      let response = await axios.get(`${API_URL}/master/getall/SERVICE_TYPE`)
      setServiceTypes(response.data.data)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchCustomerInfo = async () => {
    try {
      let response = await axios.get(`${API_URL}/customer/GetAccountDetailByID/${id}`)
      setCustomerInfo(response.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAllCustomers = async () => {
    try {
      const response = await axios.get(`${API_URL}/customer/getall-shortlist/CONSUMER/0`)
      const list = response.data.data || []
      setAllCustomers(
        list
          .filter((d: any) => String(d.key) !== String(id))
          .map((d: any) => ({value: d.key, label: d.value}))
      )
    } catch (error) {
      console.error(error)
    }
  }

  const fetchAllCustomerRate = async (payload: any) => {
    const params = new URLSearchParams({
      page: currentPage.toString(),
      items_per_page: rowsPerPage.toString(),
    }).toString()

    const obj = {
      ...payload,
      userId: id,
      fK_LanguageTo: payload.fK_LanguageTo.map((item: any) => item.value),
      fK_CommunicationType: payload.fK_CommunicationType.map((item: any) => item.value),
      fK_ServiceType: payload.fK_ServiceType.map((item: any) => item.value),
      isActive:
        payload.status === 'active' ? true : payload.status === 'inactive' ? false : null,
    }

    try {
      setIsLoading(true)
      let response = await axios.post(`${API_URL}/rates/rate-filter?${params}`, obj)
      const {data, payload} = response.data
      setInitialRows(
        data.map((rate: any) => ({
          ...rate,
          fK_CommunicationType: rate.communicationTypeList,
          fK_LanguageTo: rate.toLanguageList,
          fK_ServiceType: rate.serviceTypeList,
          days: rate.dayList,
        }))
      )
      setTotalPages(payload.pagination.last_page)
      setTotalItems(payload.pagination.total)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  // CSV Export logic
  const handleExport = async () => {
    setIsExporting(true)
    let exportData = initialRows
    
    try {
      const hasFilter = filterValues && (
        (filterValues.fK_LanguageFrom && filterValues.fK_LanguageFrom !== 'EN') ||
        (filterValues.fK_LanguageTo && filterValues.fK_LanguageTo.length > 0) ||
        (filterValues.fK_ServiceType && filterValues.fK_ServiceType.length > 0) ||
        (filterValues.fK_CommunicationType && filterValues.fK_CommunicationType.length > 0) ||
        (filterValues.status && filterValues.status !== 'all')
      )

      if (hasFilter) {
        const obj = {
          ...filterValues,
          userId: id,
          fK_LanguageTo: filterValues.fK_LanguageTo.map((item: any) => item.value),
          fK_CommunicationType: filterValues.fK_CommunicationType.map((item: any) => item.value),
          fK_ServiceType: filterValues.fK_ServiceType.map((item: any) => item.value),
          isActive:
            filterValues.status === 'active'
              ? true
              : filterValues.status === 'inactive'
              ? false
              : null,
        }

        const response = await axios.post(`${API_URL}/rates/rate-filter?page=1&items_per_page=100000`, obj)
        exportData = response.data?.data || []
      }
      
      // Prepare CSV data
      const header = [
        'Account ID',
        'Account Name',
        'Account Email',
        'From Language',
        'To Language',
        'Communication Type',
        'Service Type',
        'Start Time',
        'End Time',
        'Minimum Billable',
        'Increments',
        'Days',
        'Regular',
        'Rush',
        'Emergency',
        'Conference Charge',
        'Status'
      ]

      const rows = exportData.map((rate: any) => [
        id || '',
        customerInfo?.name || '',
        customerInfo?.customerEmail || '',
        rate.languageFrom || '',
        Array.isArray(rate.toLanguageList) ? rate.toLanguageList.map((lang: any) => lang.label || lang.value || '').join(', ') : '',
        Array.isArray(rate.communicationTypeList) ? rate.communicationTypeList.map((comm: any) => comm.label || comm.value || '').join(', ') : '',
        Array.isArray(rate.serviceTypeList) ? rate.serviceTypeList.map((service: any) => service.label || service.value || '').join(', ') : '',
        rate.startTime || '',
        rate.endTime || '',
        `${rate.minimumBillableHours || 0}:${rate.minimumBillableMinutes || 0}`,
        `${rate.incrementsHours || 0}:${rate.incrementsMinutes || 0}`,
        Array.isArray(rate.dayList) ? rate.dayList.map((day: any) => day.label || day.value || '').join(', ') : '',
        rate.regularRate || '',
        rate.rushRate || '',
        rate.emergencyRate || '',
        rate.conferenceCharges || '',
        rate.isActive ? 'Active' : 'Inactive'
      ])
      
      // Build CSV
      const escapeCSV = (val: string) => `"${String(val).replace(/"/g, '""')}"`
      const csv = [header.map(escapeCSV).join(','), ...rows.map(row => row.map(escapeCSV).join(','))].join('\r\n')

      // Download CSV with UTF-8 BOM to ensure Excel correctly interprets special characters
      const BOM = '\uFEFF'
      const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `Customer_Rates_${new Date().toISOString().split('T')[0]}.csv`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
      
    } catch (error) {
      console.error('Export error:', error)
    } finally {
      setIsExporting(false)
    }
  }

  // Copy Rates handlers
  const handleOpenCopyModal = () => {
    fetchAllCustomers()
    setSelectedSourceCustomer(null)
    setShowCopyModal(true)
  }

  const handleCopySubmit = () => {
    if (!selectedSourceCustomer) return
    setShowCopyModal(false)
    setShowCopyConfirm(true)
  }

  const handleCopyConfirm = async () => {
    if (!selectedSourceCustomer || !id) return
    setIsCopying(true)
    try {
      const response = await axios.post(`${API_URL}/rates/copy-rates`, {
        sourceCustomerId: selectedSourceCustomer.value,
        targetCustomerIds: [Number(id)],
      })
      if (response.data?.status === 'S') {
        alert(response.data.text || 'Rates copied successfully!')
        fetchAllCustomerRate(filterValues)
      } else {
        alert(response.data?.text || 'Failed to copy rates.')
      }
    } catch (error: any) {
      console.error(error)
      alert(error.response?.data?.text || 'An error occurred while copying rates.')
    } finally {
      setIsCopying(false)
      setShowCopyConfirm(false)
      setSelectedSourceCustomer(null)
    }
  }

  useEffect(() => {
    fetchLanguages()
    fetchLanguageGroups()
    fetchAllServices()
    fetchAllCommunicationType()
    fetchCustomerInfo()
  }, [])

  useEffect(() => {
    fetchAllCustomerRate(filterValues)
  }, [currentPage, rowsPerPage])

  return (
    <>
      <div className='modal fade' tabIndex={-1} id='kt_delete_confirm_cus'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Delete Confirmation</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <div className='text-center'>
                <div className='symbol symbol-100px '>
                  <img src='/media/other/delete.gif' alt='' />
                </div>
              </div>
              <h4 style={{textAlign: 'center'}}>Are you sure you want to delete this?</h4>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Close
              </button>

              <button type='button' className='btn btn-danger btn-sm' data-bs-dismiss='modal'>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Copy Rates - Select Customer Modal */}
      {showCopyModal && (
        <div className='modal fade show d-block' tabIndex={-1} style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header py-2'>
                <h4 className='modal-title'>Copy Rates From Another Customer</h4>
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  onClick={() => setShowCopyModal(false)}
                  aria-label='Close'
                >
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                </div>
              </div>
              <div className='modal-body'>
                <div className='mb-3'>
                  <label className='form-label required'>Select Source Customer</label>
                  <Select
                    className='react-select-styled react-select-solid react-select-sm'
                    classNamePrefix='react-select'
                    options={allCustomers}
                    value={selectedSourceCustomer}
                    onChange={(option: any) => setSelectedSourceCustomer(option)}
                    placeholder='Search and select a customer...'
                    isClearable
                    styles={{
                      control: (provided: any) => ({
                        ...provided,
                        border: '1px solid #e4e6ef',
                        minHeight: '33px',
                      }),
                    }}
                  />
                </div>
                <div className='alert alert-info py-2'>
                  <div className='d-flex align-items-center'>
                    <i className='bi bi-info-circle me-2'></i>
                    <span style={{fontSize: '12px'}}>
                      All active rates from the selected customer will be copied to the current customer. 
                      Any existing duplicate rates will be disabled before adding the new ones.
                    </span>
                  </div>
                </div>
              </div>
              <div className='modal-footer py-3'>
                <button
                  type='button'
                  className='btn btn-light btn-sm'
                  onClick={() => setShowCopyModal(false)}
                >
                  Cancel
                </button>
                <button
                  type='button'
                  className='btn btn-primary btn-sm'
                  disabled={!selectedSourceCustomer}
                  onClick={handleCopySubmit}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Copy Rates - Confirmation Modal */}
      {showCopyConfirm && (
        <div className='modal fade show d-block' tabIndex={-1} style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='modal-header py-2'>
                <h4 className='modal-title'>Confirm Copy Rates</h4>
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  onClick={() => {
                    setShowCopyConfirm(false)
                    setSelectedSourceCustomer(null)
                  }}
                  aria-label='Close'
                >
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                </div>
              </div>
              <div className='modal-body'>
                <div className='text-center mb-3'>
                  <i className='bi bi-exclamation-triangle text-warning' style={{fontSize: '48px'}}></i>
                </div>
                <h5 style={{textAlign: 'center'}}>
                  Are you sure you want to copy all rates from <strong>{selectedSourceCustomer?.label}</strong> to the current customer?
                </h5>
                <p className='text-muted text-center' style={{fontSize: '12px'}}>
                  Existing duplicate rates will be disabled and replaced with the source customer's rates.
                </p>
              </div>
              <div className='modal-footer py-3'>
                <button
                  type='button'
                  className='btn btn-light btn-sm'
                  onClick={() => {
                    setShowCopyConfirm(false)
                    setSelectedSourceCustomer(null)
                  }}
                  disabled={isCopying}
                >
                  Cancel
                </button>
                <button
                  type='button'
                  className='btn btn-primary btn-sm'
                  onClick={handleCopyConfirm}
                  disabled={isCopying}
                >
                  {isCopying ? (
                    <>
                      <span className='spinner-border spinner-border-sm me-2' role='status'></span>
                      Copying...
                    </>
                  ) : (
                    'Yes, Copy Rates'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <CreateRateModal
        title='Add Customer Rate'
        languages={languages}
        languageGroups={languageGroups}
        serviceTypes={serviceTypes}
        communicationTypes={communicationTypes}
        rateCategory='C'
        fetchAllCustomerRate={fetchAllCustomerRate}
      />

      <BulkCustomerRateUploadModal
        open={showBulkUploadModal}
        customerId={id ?? ''}
        onClose={() => setShowBulkUploadModal(false)}
        onComplete={() => fetchAllCustomerRate(filterValues)}
      />

      <div className='card-body p-0'>
        <div className='d-flex justify-content-between mb-3 align-items-center flex-wrap'>
          <div className='card-title d-flex align-items-center me-4'>
            <div className='d-flex flex-column'>
              <div className='d-flex align-items-center'>
                <h5 className='text-black fs-4 fw-semibold mb-0'>Customer Rates</h5>
              </div>
              {currentUser?.result.userType == 'SYSTEM' && (
                <div className='d-flex flex-wrap fs-6 '>
                  <p className='text-gray-500 mb-0 fw-normal' style={{fontSize: '12px'}}>
                    Add and Edit Customer Rates
                  </p>
                </div>
              )}
              {currentUser?.result.userType == 'SYSTEM' && (
                <div className='d-flex flex-wrap fs-6 '>
                  <p className='text-danger mb-0 fw-normal' style={{fontSize: '12px'}}>
                    *The rate times are set according to the Customer's time zone.
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className='d-flex justify-content-end align-items-center'>
            <div className='d-flex align-items-center'>
              <div className='my-0 me-3' style={{display: 'flex', justifyContent: 'end'}}>
                <RateCustomerFilterDropdown
                  languages={languages}
                  serviceTypes={serviceTypes}
                  communicationTypes={communicationTypes}
                  fetchAllCustomerRate={fetchAllCustomerRate}
                  filterValues={filterValues}
                  setFilterValues={setFilterValues}
                  rowsPerPage={rowsPerPage}
                  currentPage={currentPage}
                  setRowsPerPage={setRowsPerPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>

            {currentUser?.result.userType == 'SYSTEM' && (
              <>
                <div className='d-flex align-items-center'>
                  <OverlayTrigger
                    placement='top'
                    overlay={<Tooltip id='tooltip-copy-rates'>Copy Rates</Tooltip>}
                  >
                    <div>
                      <button
                        type='button'
                        className='btn btn-sm btn-primary btn-icon'
                        onClick={handleOpenCopyModal}
                        disabled={isCopying}
                      >
                        {isCopying ? (
                          <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                        ) : (
                          <i className='bi bi-clipboard-check fs-3'></i>
                        )}
                      </button>
                    </div>
                  </OverlayTrigger>
                </div>

                <div className='d-flex align-items-center'>
                  <OverlayTrigger
                    placement='top'
                    overlay={<Tooltip id='tooltip-export'>Export to CSV</Tooltip>}
                  >
                    <div className='ms-3'>
                      <button
                        type='button'
                        className='btn btn-sm btn-primary btn-icon'
                        onClick={handleExport}
                        disabled={isExporting}
                      >
                        {isExporting ? (
                          <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                        ) : (
                          <KTSVG path='/media/icons/duotune/files/fil017.svg' className='svg-icon-muted' />
                        )}
                      </button>
                    </div>
                  </OverlayTrigger>
                </div>
                
                <div className='d-flex align-items-center'>
                  <OverlayTrigger
                    placement='top'
                    overlay={<Tooltip id='tooltip-add-rate'>Add Customer Rate</Tooltip>}
                  >
                    <div className='ms-3'>
                      <Dropdown align='end'>
                        <Dropdown.Toggle
                          variant='primary'
                          id='add-customer-rate-dropdown'
                          className='btn btn-sm btn-primary btn-icon no-caret'
                        >
                          <i className='bi bi-plus fs-2'></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            data-bs-toggle='modal'
                            data-bs-target='#kt_add_acc_rate'
                          >
                            Add Customer Rate
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => setShowBulkUploadModal(true)}>
                            Bulk Import
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </OverlayTrigger>
                </div>
              </>
            )}
          </div>
        </div>

        <div className='row g-1'>
          <div className='py-0 pt-3'>
            <EditableTable
              initialRows={initialRows}
              fetchAllCustomerRate={fetchAllCustomerRate}
              rateCategory='C'
              currentPage={currentPage}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              totalItems={totalItems}
              setRowsPerPage={setRowsPerPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
        {isLoading && <CommonLoading />}
      </div>
    </>
  )
}
